export const RECEIVE_USERS = 'RECEIVE_USERS';
export const CLEAR_LIST = 'CLEAR_LIST';